import React from "react";
import { Card, Icon, Tooltip, InputNumber, Tag } from "antd";
// import img from "../../img/catinfosample.jpeg";
import "./styles.css";
import abilitylist from "../utilities/abilitylist";

const reactStringReplace = require("react-string-replace");

const convertBasedOnLevel = require("../utilities/calc-stats");

// const samplecat = {
//   sampledata: {
//     key: "356-3",
//     name: "Orbital Annihilator Ragnarok",
//     number: "356-3",
//     form: "True",
//     rarity: "Uber Super Rare",
//     level: 1,
//     health: 6000,
//     damage: 13000,
//     range: 470,
//     kb: 8,
//     speed: 8,
//     dps: 1822,
//     target: "Area",
//     tba: "7.17",
//     anim: "4.43",
//     spawn: "178.20",
//     cost: 4500,
//     ability:
//       "u1Against red, black, floating, metal, angel, alien, zombie, relicu2: u1Attacks onlyu2b1 redb2,b1 blackb2,b1 floatingb2,b1 metalb2,b1 angelb2,b1 alienb2,b1 zombieb2,b1 relicb2 u1General Abilitiesu2: b1Zombie Killerb2 (Stops zombies from reviving) b1Omni Strikeb2 (Effective range -470~470)",
//     iscrazed: null
//   }
// };

class SingleCatCard extends React.Component {
  state = {
    catLevel: 30,
    cat: {
      key: "",
      name: "",
      number: "",
      form: "",
      rarity: "",
      level: 0,
      health: 0,
      damage: 0,
      range: 0,
      kb: 0,
      speed: 0,
      dps: 0,
      target: "",
      tba: "",
      anim: "",
      spawn: "",
      cost: 0,
      ability: "",
      iscrazed: null,
    },
  };

  componentDidMount() {
    // console.log(this.props.catno);
  }

  onInputNumberChange(value) {
    if (value > 0 && value < 1000) {
      this.setState({
        catLevel: value,
      });
    }
  }

  getAbilityTags() {
    const abilitytags = [];
    const fullability = this.props.selectedCat.ability;
    abilitylist.forEach(function (ability) {
      if (fullability.match(new RegExp(ability.value)) !== null) {
        abilitytags.push(
          <Tooltip
            placement="topLeft"
            title={ability.text}
            key={abilitytags.length}
          >
            {ability.img}
            <span style={{ display: "inline-block", width: "2px" }} />
          </Tooltip>
        );
      }
    });

    return abilitytags;
  }

  render() {
    const dataSource = this.props.selectedCat;

    const cardWidth =
      this.props.viewportWidth > 948
        ? this.props.viewportWidth / 3 - 4
        : this.props.viewportWidth > 636
        ? this.props.viewportWidth / 2 - 6
        : this.props.viewportWidth - 24;

    let abilitycopy = dataSource.ability;
    let formattedb = reactStringReplace(
      abilitycopy,
      /b1(.+?)b2/g,
      (match, i) => <b key={"b" + i}>{match}</b>
    );
    let formattedu = reactStringReplace(
      formattedb,
      /u1(.+?)u2/g,
      (match, i) => <u key={"u" + i}>{match}</u>
    );

    const gridStyleA = {
      width: "1/3%",
      textAlign: "center",
      padding: "4px",
      WebkitBoxShadow: "0 0 0 0",
      fontWeight: "bold",
      fontSize: "20px",
    };

    // const gridStyleB = {
    //   width: "50%",
    //   textAlign: "left",
    //   padding: "0px",
    //   WebkitBoxShadow: "0 0 0 0",
    //   fontWeight: "bold",
    //   height: "24px",
    //   verticalAlign: "center"
    // };

    const gridStyleC = {
      textAlign: "center",
      fontWeight: "normal",
      fontSize: "14px",
      marginBottom: "0px",
    };

    const gridStyleD = {
      width: "100%",
      textAlign: "left",
      fontWeight: "normal",
      fontSize: "14px",
      marginBottom: "0px",
      WebkitBoxShadow: "0 0 0 0",
      padding: "0px 0 0 0",
    };

    const gridStyleE = {
      width: "100%",
      textAlign: "center",
      fontWeight: "normal",
      fontSize: "14px",
      marginBottom: "0px",
      WebkitBoxShadow: "0 0 0 0",
      padding: "0px 0 0 0",
    };

    const gridStyleF = {
      width: "100%",
      textAlign: "left",
      fontWeight: "normal",
      fontSize: "14px",
      marginBottom: "0px",
      WebkitBoxShadow: "0 0 0 0",
      padding: "12px 24px 12px 24px",
    };

    const catExists = (
      <div
        style={{
          display: "inline-block",
          padding: "0 12px 12px 0",
        }}
      >
        <Card
          title={
            <div>
              <div>
                <img
                  style={{
                    float: "left",
                    display: "inline-block",
                    padding: "0 6px 0 0 ",
                  }}
                  src={
                    "https://onestoppress.com/images/" +
                    dataSource.number +
                    ".png"
                  }
                  // src={img}
                  alt={dataSource.name}
                />
                <div style={{ display: "-webkit-box" }}>
                  <h3
                    style={{
                      // float: "right",
                      overflowWrap: "break-word",
                      wordBreak: "break-word",
                      // maxWidth: "140px",
                      // height: "80px",
                      // display: "block",
                      whiteSpace: "normal",
                      // padding: "0 0 0 6px",
                      lineHeight: "1.3",
                      margin: "0px",
                    }}
                  >
                    {dataSource.name}
                    <br />
                    <Tag style={{ fontSize: "12px" }} color="#f90">
                      {dataSource.form}
                    </Tag>
                    <Tag style={{ fontSize: "12px" }} color="#dea207">
                      {dataSource.rarity.split(" ")[0]}
                    </Tag>
                    <br />
                  </h3>
                </div>
              </div>
            </div>
          }
          //   extra={dataSource.name}
          style={{
            minWidth: 300,
            maxWidth: 350,
            width: cardWidth,
            verticalAlign: "top",
          }}
          className="cardcss"
        >
          <Card.Grid style={gridStyleF}>
            <Card.Grid style={gridStyleD}>
              <div style={{ fontWeight: "bold" }}>Abilities</div>
              <div>{this.getAbilityTags()}</div>
              <hr />
            </Card.Grid>

            <Card.Grid style={gridStyleE}>
              <div style={{ padding: "0 0 0 0", margin: "0 0 0 0" }}>
                Level: &nbsp;
                <InputNumber
                  style={{ width: "55px" }}
                  min={1}
                  max={999}
                  defaultValue={30}
                  size="small"
                  onChange={this.onInputNumberChange.bind(this)}
                />
              </div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              ${dataSource.cost}
              <div style={gridStyleC}>Cost</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {Math.round(
                convertBasedOnLevel(
                  dataSource.rarity,
                  this.state.catLevel,
                  dataSource.iscrazed,
                  dataSource.name
                    .toLowerCase()
                    .includes("Bahamut".toLowerCase()),
                  dataSource.health
                )
              )}
              <div style={gridStyleC}>Health</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {Math.round(
                convertBasedOnLevel(
                  dataSource.rarity,
                  this.state.catLevel,
                  dataSource.iscrazed,
                  dataSource.name
                    .toLowerCase()
                    .includes("Bahamut".toLowerCase()),
                  dataSource.damage
                )
              )}
              <div style={gridStyleC}>Damage</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.range}
              <div style={gridStyleC}>Range</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.kb}
              <div style={gridStyleC}>KB</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.speed}
              <div style={gridStyleC}>Speed</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {Math.round(
                convertBasedOnLevel(
                  dataSource.rarity,
                  this.state.catLevel,
                  dataSource.iscrazed,
                  dataSource.name
                    .toLowerCase()
                    .includes("Bahamut".toLowerCase()),
                  dataSource.dps
                )
              )}
              <div style={gridStyleC}>DPS</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.tba}s
              <div style={gridStyleC}>
                TBA{" "}
                <Tooltip title="Time Between Attacks" placement="topLeft">
                  <Icon
                    type="info-circle"
                    style={{ fontSize: "12px", verticalAlign: "top" }}
                  />
                </Tooltip>
              </div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.anim}s<div style={gridStyleC}>Animation</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.spawn}s<div style={gridStyleC}>Spawn</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.target}
              <div style={gridStyleC}>Target</div>
            </Card.Grid>

            <Card.Grid style={gridStyleD}>
              <hr />
              <div style={{ fontWeight: "bold" }}>Special Ability:</div>
              <div style={{ margin: "6px 0 0 0 ", whiteSpace: "pre-wrap" }}>
                {formattedu}
              </div>
            </Card.Grid>
            <Card.Grid style={gridStyleD}>
              <hr />
              <div style={{ fontWeight: "bold" }}>Description:</div>
              <div style={{ margin: "6px 0 0 0 ", whiteSpace: "normal" }}>
                {dataSource.flavour_text}
              </div>
            </Card.Grid>
          </Card.Grid>
        </Card>
      </div>
    );
    return catExists;
  }
}

export default SingleCatCard;



// WEBPACK FOOTER //
// ./src/components/table/SingleCatCard.js